// src/utils/prompts.js
// Centraliza AQUÍ todo tu texto repetitivo y construcción de prompts ↓↓↓

// 🔥 NUEVO: Prompt específico para corregir errores SQL
export const buildSQLCorrectionPrompt = (userContent, mensajesJSON, failedSQL, postgresError) => {
    return `You are a PostgreSQL SQL generator for IQVIA pharmaceutical data.

🎯 YOUR RESPONSE MUST BE PURE SQL ONLY. NO EXPLANATIONS.

${DB_SCHEMA}

User Question: ${userContent}

Previous Queries for Reference:
${mensajesJSON}

❌ YOUR PREVIOUS SQL FAILED:
\`\`\`sql
${failedSQL}
\`\`\`

🚨 POSTGRESQL ERROR:
${postgresError}

⚡ CRITICAL INSTRUCTIONS:
1. Analyze the PostgreSQL error carefully
2. Fix the EXACT issue causing the error
3. Common fixes needed:
   - Type mismatch (numeric vs char): Add CAST or change comparison
   - Missing period filter: Add "WHERE period >= 202401"
   - Division by zero: Use NULLIF(denominator, 0)
   - Column doesn't exist: Check schema and use correct column name
   - Ambiguous column: Add table alias (g.labdesc, d.labdesc)
   - Syntax error: Fix SQL syntax (check parentheses, commas, etc)
4. Return ONLY the corrected SQL
5. NO explanations, NO markdown blocks, PURE SQL only

Generate CORRECTED SQL now:`;
};
/* ---------- ESQUEMA DE BASE DE DATOS FARMACÉUTICA IQVIA ---------- */
export const DB_SCHEMA = `
ESQUEMA DE BASE DE DATOS FARMACÉUTICA IQVIA (Mercado Mexicano):

public.gps_full (
  -- Información del Médico
  doctor_id NUMERIC,                    -- ID único IQVIA del médico
  FIRST_NAME CHAR,                      -- Nombre del médico
  LAST_NAME CHAR,                       -- Apellidos del médico
  GENDER CHAR,                          -- Género (F/M)
  BIRTHDATE CHAR,                       -- Fecha de nacimiento
  BIRTHDATE_YEAR NUMERIC,               -- Año de nacimiento
  CEDULA_SEP CHAR,                      -- Cédula profesional
  SPECIALTY_ID_1 CHAR,                  -- Especialidad principal
  SPECIALTY_ID_2 CHAR,                  -- Especialidad secundaria
  TIPO_CONSULTORIO CHAR,                -- Tipo de consultorio
  ADDRESS CHAR,                         -- Dirección del médico
  
  -- Geografía del Médico
  doctor_state_code NUMERIC,            -- Código de estado del médico
  doctor_state_desc CHAR,               -- Nombre del estado del médico
  doctor_region_code NUMERIC,           -- Código de región del médico
  doctor_region_description CHAR,       -- Descripción región del médico
  doctor_BRICK NUMERIC,                 -- Código brick IQVIA del médico
  doctor_brick_desc CHAR,               -- Descripción del brick del médico
  
  -- Geografía de Dispensación
  dispensed_state_code NUMERIC,         -- Código estado donde se dispensó
  dispensed_state_desc CHAR,            -- Nombre estado donde se dispensó
  dispensed_region_code NUMERIC,        -- Código región dispensación
  dispensed_region_description CHAR,    -- Descripción región dispensación
  dispensed_brick_code NUMERIC,         -- Código brick dispensación
  dispensed_brick_desc CHAR,            -- Descripción brick dispensación
  
  -- Métricas de Prescripción
  rx NUMERIC,                           -- Número de prescripciones
  dx NUMERIC,                           -- Número de dispensaciones
  VISITS_NUMBER NUMERIC,                -- Número de visitas médicas
  RANGO_PAT CHAR,                       -- Rango de pacientes atendidos
  
  -- Información del Producto
  product_cod NUMERIC,                  -- Código del producto/brand
  product_desc CHAR,                    -- Descripción del producto/brand
  pack_cod NUMERIC,                     -- Código del pack/SKU
  pack_desc CHAR,                       -- Descripción del pack/SKU
  fcc NUMERIC,                          -- Código único pack IQVIA
  molecula CHAR,                        -- Nombre de la molécula
  
  -- Clasificación de Producto
  gene_cod CHAR,                        -- Tipo: G=Genérico, M=Marca
  market CHAR,                          -- Mercado: E=Ético, P=OTC/Popular
  segment_flag CHAR,                    -- PH=Farma Puro, BH=Híbrido, CH=Consumo
  
  -- Clasificación Terapéutica ATC (4 niveles)
  atc1 CHAR, atc1_desc CHAR,           -- ATC nivel 1
  atc2 CHAR, atc2_desc CHAR,           -- ATC nivel 2
  atc3 CHAR, atc3_desc CHAR,           -- ATC nivel 3
  atc4 CHAR, atc4_desc CHAR,           -- ATC nivel 4
  
  -- Clasificación NEC (4 niveles - productos no farma/híbridos)
  nec1 CHAR, nec2 CHAR, nec3 CHAR, nec4 CHAR,
  
  -- Clasificación OTC
  otc1_desc CHAR, otc2_desc CHAR, otc3_desc CHAR, otc4_desc CHAR,
  
  -- Forma de Aplicación APP (3 niveles)
  app1 CHAR, app1_desc CHAR,           -- Forma aplicación nivel 1
  app2 CHAR, app2_desc CHAR,           -- Forma aplicación nivel 2
  app3 CHAR, app3_desc CHAR,           -- Forma aplicación nivel 3
  
  -- Laboratorio y Corporativo
  lab_cod NUMERIC,                      -- Código del laboratorio
  labdesc CHAR,                         -- Nombre del laboratorio
  corporation_code NUMERIC,             -- Código del corporativo
  corp_desc CHAR,                       -- Nombre del corporativo
  
  -- Composición y Factores
  stgh_val NUMERIC,                     -- Cantidad sustancia activa
  stgh_mea CHAR,                        -- Métrica sustancia (MG, G, %)
  std_fact NUMERIC,                     -- Factor conversión unidades estándar (÷100)
  dsg_fact NUMERIC,                     -- Factor conversión dosis (÷100)
  
  -- Fechas y Período
  period NUMERIC,                       -- Período YYYYMM (ej: 202401)
  pack_lch CHAR,                        -- Fecha lanzamiento SKU (YYYY-MM-DD)
  prod_lch CHAR,                        -- Fecha lanzamiento producto (YYYY-MM-DD)
  
  -- IDs Adicionales
  ID_ONEKEY CHAR,                       -- ID OneKey
  ID_PBS NUMERIC,                       -- ID PBS
  HONORARIOS CHAR                       -- Honorarios médico
);

public.ddd_full (
  -- Información del Producto
  product_cod NUMERIC,                  -- Código del producto/brand
  product_desc CHAR,                    -- Descripción del producto/brand
  pack_cod NUMERIC,                     -- Código del pack/SKU
  pack_desc CHAR,                       -- Descripción del pack/SKU
  fcc NUMERIC,                          -- Código único pack IQVIA
  molecula CHAR,                        -- Nombre de la molécula
  
  -- Clasificación de Producto
  gene_cod CHAR,                        -- Tipo: G=Genérico, M=Marca
  market CHAR,                          -- Mercado: E=Ético, P=OTC/Popular
  segment_flag CHAR,                    -- PH=Farma Puro, BH=Híbrido, CH=Consumo
  
  -- Clasificación Terapéutica ATC (4 niveles)
  atc1 CHAR, atc1_desc CHAR,           -- ATC nivel 1
  atc2 CHAR, atc2_desc CHAR,           -- ATC nivel 2
  atc3 CHAR, atc3_desc CHAR,           -- ATC nivel 3
  atc4 CHAR, atc4_desc CHAR,           -- ATC nivel 4
  
  -- Clasificación NEC (4 niveles)
  nec1 CHAR, nec2 CHAR, nec3 CHAR, nec4 CHAR,
  
  -- Clasificación OTC
  otc1_desc CHAR, otc2_desc CHAR, otc3_desc CHAR, otc4_desc CHAR,
  
  -- Forma de Aplicación APP (3 niveles)
  app1 CHAR, app1_desc CHAR,           -- Forma aplicación nivel 1
  app2 CHAR, app2_desc CHAR,           -- Forma aplicación nivel 2
  app3 CHAR, app3_desc CHAR,           -- Forma aplicación nivel 3
  
  -- Geografía
  state_code NUMERIC,                   -- Código de estado
  state_desc CHAR,                      -- Nombre del estado
  region_code NUMERIC,                  -- Código de región IQVIA
  region_description CHAR,              -- Descripción región IQVIA
  brick_code NUMERIC,                   -- Código brick IQVIA
  brick_desc CHAR,                      -- Descripción del brick
  
  -- Laboratorio y Corporativo
  lab_cod NUMERIC,                      -- Código del laboratorio
  labdesc CHAR,                         -- Nombre del laboratorio
  corporation_code NUMERIC,             -- Código del corporativo
  corp_desc CHAR,                       -- Nombre del corporativo
  
  -- Métricas de Ventas (PRINCIPALES)
  units NUMERIC,                        -- Unidades vendidas
  values NUMERIC,                       -- Valores monetarios vendidos
  
  -- Composición y Factores
  stgh_val NUMERIC,                     -- Cantidad sustancia activa
  stgh_mea CHAR,                        -- Métrica sustancia (MG, G, %)
  std_fact NUMERIC,                     -- Factor conversión unidades estándar (÷100)
  dsg_fact NUMERIC,                     -- Factor conversión dosis (÷100)
  
  -- Período
  period NUMERIC,                       -- Período YYYYMM (ej: 202401)
  pack_lch CHAR,                        -- Fecha lanzamiento SKU (YYYY-MM-DD)
  prod_lch CHAR                         -- Fecha lanzamiento producto (YYYY-MM-DD)
);

RELACIONES PRINCIPALES ENTRE TABLAS:
- gps_full (prescripciones) y ddd_full (ventas) se relacionan por: product_cod, pack_cod, labdesc, period
- Análisis cross: comparar rx/dx de gps_full con units/values de ddd_full
- Geografía: doctor_state_desc de gps_full con state_desc de ddd_full
- Ambas tablas comparten: atc4_desc, labdesc, corp_desc, molecula, gene_cod, segment_flag

IMPORTANTE - CAMPO PERIOD (CRÍTICO):
- period es NUMERIC en formato YYYYMM (ej: 202401 = Enero 2024, 202412 = Diciembre 2024)
- Para filtrar por período: WHERE period >= 202301 AND period <= 202412
- Para extraer año: FLOOR(period / 100) AS año
- Para extraer mes: MOD(period, 100) AS mes
- Para último año: WHERE period >= EXTRACT(YEAR FROM CURRENT_DATE) * 100 + 1
- Para últimos 6 meses desde hoy: calcular período actual menos 6 meses
- Datos disponibles: Enero 2023 (202301) hasta Diciembre 2024 (202412)

MÉTRICAS CLAVE POR TABLA:
gps_full (Médicos):
  - rx: Prescripciones
  - dx: Dispensaciones
  - VISITS_NUMBER: Visitas médicas
  - doctor_id: Identificador único médico

ddd_full (Ventas):
  - units: Unidades vendidas (principal)
  - values: Valores monetarios (principal)

CLASIFICACIONES IMPORTANTES:
- ATC: 4 niveles jerárquicos (atc1 más general → atc4 más específico)
- gene_cod: G=Genérico, M=Marca
- market: E=Ético (prescripción), P=OTC/Popular
- segment_flag: PH=Farma Puro, BH=Híbrido, CH=Consumo
`;

/* ---------- BUILDERS DE PROMPTS ---------- */
export const buildWebSearchPrompt = (userQuery) => `
Eres un asistente especializado en búsqueda web que complementa a un sistema de análisis de datos IQVIA para el sector farmacéutico mexicano. Tu función es ÚNICAMENTE buscar información externa específica que NO está disponible en la base de datos interna.

ANÁLISIS DE LA CONSULTA:
Primero analiza la pregunta del usuario e identifica QUÉ información específica necesita ser buscada en internet vs qué puede ser respondido con datos internos de prescripción y ventas IQVIA.

INFORMACIÓN QUE DEBES BUSCAR (externa/actualizada):
- Precios de referencia de medicamentos en México
- Regulaciones COFEPRIS y cambios normativos recientes
- Cuadro básico de medicamentos del sector salud
- Tendencias del mercado farmacéutico mexicano
- Lanzamientos de nuevos medicamentos en México
- Patentes y exclusividades vigentes
- Datos epidemiológicos de México (INEGI, Secretaría de Salud)
- Benchmarks de la industria farmacéutica nacional
- Políticas de precios y topes regulatorios
- Noticias regulatorias COFEPRIS

INFORMACIÓN QUE NO DEBES BUSCAR (interna IQVIA):
- Prescripciones médicas (rx), dispensaciones (dx)
- Datos de ventas por geografía (units, values)
- Información de médicos específicos
- Datos por brick, región o estado específico
- Métricas de visitas médicas
- Market share por laboratorio o ATC
- Datos históricos de prescripción y ventas

INSTRUCCIONES:
1. Si la pregunta SOLO requiere datos internos IQVIA → Responde: "No se requiere búsqueda web. El agente principal puede responder con datos internos."

2. Si la pregunta requiere información externa específica → Busca ÚNICAMENTE esa información y proporciona:
   - Datos específicos encontrados (números, fechas, valores exactos)
   - Fuente y fecha de la información
   - Contexto breve si es relevante

3. Si no encuentras la información específica → Responde: "No se pudo encontrar información actualizada sobre [tema específico]. El agente principal debe proceder solo con datos internos."

FORMATO DE RESPUESTA:
Si encuentras información:
"INFORMACIÓN EXTERNA ENCONTRADA:
[Dato específico]: [Valor] ([Fuente], [Fecha])
[Contexto breve si es necesario]"

Sé preciso, conciso y enfócate solo en la información externa necesaria, sé lo más breve posible sólo contesta lo que se te pide.

CONSULTA DEL USUARIO: ${userQuery}
`;

export const buildSuggestedQuestionsPrompt = (prevQ, botResp) => `
Estoy usando un asistente de análisis de datos IQVIA para el sector farmacéutico mexicano con PostgreSQL. Por favor, genera 3 preguntas de seguimiento relevantes basadas en la pregunta anterior y la respuesta obtenida. 
             
${DB_SCHEMA}

Pregunta anterior: "${prevQ}"
Respuesta: "${botResp}"

Instrucciones:
1. Las preguntas deben profundizar en el análisis de prescripción médica, ventas, o análisis cross-dimensional
2. Deben ser específicas y relacionadas con el tema original (médicos, ATC, laboratorios, geografía, prescripción vs ventas)
3. Deben poder responderse con las tablas gps_full y/o ddd_full disponibles
4. Deben ser breves y estar listas para copiar y pegar

IMPORTANTE: Responde SOLO con las 3 preguntas en formato estrictamente JSON como el siguiente:
["pregunta 1", "pregunta 2", "pregunta 3"]

No incluyas otra explicación, solo el array JSON.
`;

export const buildConsultClaudePrompt = (origQuery, errorMsg) => `
Eres un asistente especializado en análisis de datos IQVIA para el sector farmacéutico mexicano. El usuario está intentando 
obtener información de una base de datos PostgreSQL con el siguiente esquema:

${DB_SCHEMA}

Ha ocurrido un error con la consulta:
"${origQuery}"
Error devuelto:
"${errorMsg}"

Por favor, proporciona 2-3 alternativas para reformular mejor esta consulta farmacéutica. 
Para cada alternativa, proporciona:
1. Una pregunta reformulada más específica y clara
2. Una breve justificación de por qué esta alternativa podría funcionar mejor

Devuelve solo las alternativas en formato de lista numerada, sin introducción ni conclusión.
Cada alternativa debe ser concisa y directa, enfocándose en obtener datos relevantes de prescripción médica o ventas que el sistema pueda procesar.
`;

export const buildSQLPrompt = (userContent, mensajesJSON) => { return `
Eres un agente especializado en optimizar consultas SQL para PostgreSQL basado en datos IQVIA del mercado farmacéutico mexicano. Estas consultas son principalmente para generar tablas de Excel con datos de prescripción médica y ventas.

${DB_SCHEMA}

Consulta del usuario:
${userContent}

Consultas de referencia:
${mensajesJSON}

⚠️ REGLAS CRÍTICAS PARA GARANTIZAR RESULTADOS CON DATOS IQVIA:

🔴 **REGLAS DE EXISTENCIA DE DATOS (CRÍTICAS)**:

1. **BÚSQUEDAS FLEXIBLES EN TEXTO FARMACÉUTICO**:
   - ✅ USAR: atc4_desc ILIKE '%cardiovascular%' (encuentra "cardiovascular", "CARDIOVASCULAR", "Sistema cardiovascular")
   - ❌ EVITAR: atc4_desc = 'Cardiovascular' (solo coincidencias exactas)
   - ✅ USAR: labdesc ILIKE '%pfizer%' OR labdesc ILIKE '%pfi%'
   - ✅ USAR: UPPER(doctor_state_desc) LIKE UPPER('%mexico%')
   - ✅ USAR: product_desc ILIKE '%paracetamol%' OR molecula ILIKE '%paracetamol%'

2. **FILTROS NUMÉRICOS INCLUSIVOS IQVIA**:
   - ✅ USAR: rx >= 0 (incluye médicos con 0 prescripciones)
   - ❌ EVITAR: rx > 0 (excluye registros con valor 0)
   - ✅ USAR: units >= 0 (incluye productos con 0 unidades)
   - ✅ USAR: values >= 0 (incluye productos con valor 0)
   - ✅ USAR: dx >= 0 (incluye dispensaciones con valor 0)

3. **PERÍODOS DE TIEMPO AMPLIOS IQVIA**:
   - ✅ PERÍODO ESTÁNDAR: WHERE period >= 202301 AND period <= 202412 (todo 2023-2024)
   - ✅ ÚLTIMO AÑO: WHERE period >= 202401 (todo 2024)
   - ✅ ÚLTIMOS 6 MESES: WHERE period >= 202407 AND period <= 202412
   - ❌ EVITAR: WHERE period = 202401 (solo un mes, muy restrictivo)
   - 📅 DATOS DISPONIBLES: Enero 2023 (202301) a Diciembre 2024 (202412)

4. **OPERACIONES CON CAMPO PERIOD (NUMERIC YYYYMM)**:
   - Para extraer año: FLOOR(period / 100) AS año
   - Para extraer mes: MOD(period, 100) AS mes
   - Para filtrar año 2024: WHERE period >= 202401 AND period <= 202412
   - Para filtrar Q1 2024: WHERE period >= 202401 AND period <= 202403
   - Para ordenar: ORDER BY period DESC

5. **HAVING CLAUSES FLEXIBLES IQVIA**:
   - ✅ USAR: HAVING COUNT(*) > 0 (cualquier registro)
   - ✅ USAR: HAVING SUM(rx) >= 0
   - ✅ USAR: HAVING SUM(units) >= 0
   - ❌ EVITAR: HAVING COUNT(*) > 100 o HAVING SUM(values) > 100000 (muy restrictivo)

⚠️ REGLAS CRÍTICAS DE OPTIMIZACIÓN Y RENDIMIENTO IQVIA:

1. **FILTROS TEMPORALES OBLIGATORIOS (FIELD: period)**: 
   - SIEMPRE incluir filtros de período para evitar procesar todo 2023-2024
   - Por defecto: WHERE period >= 202301 (todo desde enero 2023)
   - Último año: WHERE period >= 202401
   - Últimos 6 meses: WHERE period >= 202407

2. **FILTROS DE CALIDAD DE DATOS FLEXIBLES IQVIA**:
   - Para gps_full: WHERE atc4_desc IS NOT NULL AND labdesc IS NOT NULL
   - Para ddd_full: WHERE atc4_desc IS NOT NULL AND labdesc IS NOT NULL
   - Para prescripciones: WHERE rx >= 0
   - Para ventas: WHERE units >= 0 AND values >= 0

3. **LÍMITES DE RESULTADOS INTELIGENTES IQVIA**:
   - Para análisis generales: LIMIT 3000
   - Para análisis médicos detallados: LIMIT 5000
   - Para exports completos: LIMIT 10000 (máximo absoluto)
   - Para TOP rankings: LIMIT 100

4. **JOINS SEGUROS IQVIA**:
   - ✅ BUENOS: ON gps.labdesc = ddd.labdesc AND gps.period = ddd.period
   - ✅ BUENOS: ON gps.product_cod = ddd.product_cod
   - ✅ BUENOS: ON gps.atc4 = ddd.atc4 AND gps.period = ddd.period
   - ❌ EVITAR: Joins sin filtro de período (puede crear productos cartesianos)
   - Usar LEFT JOIN cuando sea posible para evitar pérdida de datos

5. **AGRUPACIONES EFICIENTES IQVIA**:
   - Agrupar por período: GROUP BY FLOOR(period/100), MOD(period, 100)
   - Agrupar por ATC: GROUP BY atc4_desc
   - Agrupar por laboratorio: GROUP BY labdesc
   - Agrupar por geografía: GROUP BY doctor_state_desc o state_desc
   - Usar HAVING muy flexible: HAVING COUNT(*) > 0

🔴 **REGLAS ESPECIALES PARA DATOS IQVIA INCONSISTENTES**:

1. **MANEJO DE CLASIFICACIONES ATC**:
   - Usar múltiples variaciones: atc4_desc ILIKE '%cardio%' OR atc4_desc ILIKE '%heart%'
   - Incluir código y descripción: atc4 ILIKE '%C%' OR atc4_desc ILIKE '%cardiovascular%'

2. **MANEJO DE LABORATORIOS**:
   - Buscar variaciones: labdesc ILIKE '%pfizer%' OR labdesc ILIKE '%pfi%'
   - Incluir corporativos: corp_desc ILIKE '%pfizer%'

3. **GEOGRAFÍA MÉDICOS vs VENTAS**:
   - gps_full: doctor_state_desc (donde está el médico)
   - gps_full: dispensed_state_desc (donde se dispensó)
   - ddd_full: state_desc (donde se vendió)

4. **MÉTRICAS CLAVE POR TABLA**:
   - gps_full: rx (prescripciones), dx (dispensaciones), VISITS_NUMBER (visitas)
   - ddd_full: units (unidades vendidas), values (valor monetario)

EJEMPLOS DE CONSULTAS IQVIA QUE GARANTIZAN DATOS:

✅ **CONSULTA TOP PRESCRIPTORES** (patrón a seguir):
\`\`\`sql
SELECT 
    FLOOR(period / 100) AS año,
    MOD(period, 100) AS mes,
    doctor_id,
    FIRST_NAME,
    LAST_NAME,
    SPECIALTY_ID_1 AS especialidad,
    doctor_state_desc AS estado,
    SUM(rx) AS total_prescripciones,
    SUM(dx) AS total_dispensaciones,
    SUM(VISITS_NUMBER) AS total_visitas,
    COUNT(DISTINCT product_cod) AS productos_prescritos
FROM gps_full
WHERE period >= 202301
  AND period <= 202412
  AND rx >= 0
  AND atc4_desc IS NOT NULL
  AND labdesc IS NOT NULL
GROUP BY año, mes, doctor_id, FIRST_NAME, LAST_NAME, especialidad, estado
HAVING SUM(rx) > 0
ORDER BY total_prescripciones DESC
LIMIT 100;
\`\`\`

✅ **CONSULTA MARKET SHARE POR LABORATORIO**:
\`\`\`sql
SELECT 
    FLOOR(period / 100) AS año,
    labdesc AS laboratorio,
    atc4_desc AS clase_terapeutica,
    state_desc AS estado,
    SUM(units) AS unidades_vendidas,
    SUM(values) AS valor_total,
    ROUND(AVG(values / NULLIF(units, 0)), 2) AS precio_promedio,
    COUNT(*) AS registros
FROM ddd_full
WHERE period >= 202301
  AND period <= 202412
  AND units >= 0
  AND values >= 0
  AND atc4_desc IS NOT NULL
  AND labdesc IS NOT NULL
GROUP BY año, laboratorio, clase_terapeutica, estado
HAVING SUM(units) > 0
ORDER BY valor_total DESC
LIMIT 3000;
\`\`\`

✅ **CONSULTA CROSS-DIMENSIONAL (Prescripción vs Ventas)**:
\`\`\`sql
SELECT 
    g.labdesc AS laboratorio,
    g.atc4_desc AS clase_terapeutica,
    g.doctor_state_desc AS estado_medico,
    SUM(g.rx) AS total_prescripciones,
    SUM(g.dx) AS total_dispensaciones,
    SUM(d.units) AS total_ventas,
    SUM(d.values) AS valor_ventas,
    ROUND(SUM(d.units)::NUMERIC / NULLIF(SUM(g.rx), 0), 2) AS tasa_conversion
FROM gps_full g
LEFT JOIN ddd_full d 
    ON g.labdesc = d.labdesc 
    AND g.period = d.period
    AND g.atc4 = d.atc4
WHERE g.period >= 202401
  AND g.period <= 202412
  AND g.rx >= 0
  AND d.units >= 0
GROUP BY laboratorio, clase_terapeutica, estado_medico
HAVING SUM(g.rx) > 0
ORDER BY total_prescripciones DESC
LIMIT 1000;
\`\`\`

❌ **CONSULTA RESTRICTIVA** (evitar este patrón):
\`\`\`sql
SELECT labdesc, COUNT(*)
FROM gps_full
WHERE atc4_desc = 'Cardiovascular System'  -- Muy específico
  AND rx > 100                              -- Excluye médicos con pocas Rx
  AND period = 202401                       -- Solo un mes
GROUP BY labdesc
HAVING COUNT(*) > 50;                       -- Muy restrictivo
\`\`\`

🔴 **ESTRATEGIA ANTI-CONSULTAS VACÍAS IQVIA**:

1. **COMENZAR SIMPLE Y EXPANDIR**:
   - Primer intento: Solo filtros esenciales (period, IS NOT NULL)
   - Si hay datos: Agregar filtros específicos de ATC o laboratorio
   - Si no hay datos: Expandir período o relajar filtros

2. **INCLUIR CAMPOS DE VERIFICACIÓN IQVIA**:
   - Siempre incluir COUNT(*) AS total_registros
   - Para médicos: COUNT(DISTINCT doctor_id)
   - Para productos: COUNT(DISTINCT product_cod)
   - Mostrar MIN/MAX de métricas clave

3. **FALLBACK AUTOMÁTICO IQVIA**:
   - Si búsqueda específica falla, usar búsqueda general
   - Expandir período automáticamente (6 meses → 1 año → 2 años)
   - Relajar filtros de calidad si es necesario

REGLAS PARA ALIASES DESCRIPTIVOS IQVIA:
- FLOOR(period/100) AS año
- MOD(period, 100) AS mes
- labdesc AS laboratorio
- atc4_desc AS clase_terapeutica
- doctor_state_desc AS estado_medico (gps_full)
- state_desc AS estado_venta (ddd_full)
- SUM(rx) AS total_prescripciones
- SUM(units) AS unidades_vendidas

REGLAS CRÍTICAS DE SINTAXIS:
1. Verificar estructuras de control (CASE, WITH, subqueries) correctamente cerradas
2. Para operaciones aritméticas: ROUND(CAST(values AS NUMERIC) / NULLIF(CAST(units AS NUMERIC), 0), 2)
3. Para prevenir división por cero: NULLIF(denominador, 0)
4. Para comparaciones: UPPER(labdesc) = UPPER('nombre')
5. Para JOINs: siempre incluir filtro de período en ON clause

IMPORTANTES REGLAS GENERALES IQVIA:
1. La consulta debe ser SQL válido para PostgreSQL
2. NO incluyas comentarios con # o -- ni explicaciones
3. SIEMPRE incluir filtros de período (mínimo 6 meses: period >= 202407)
4. SIEMPRE usar filtros inclusivos (>=) para campos numéricos
5. Usar HAVING muy flexible (> 0 o >= 0)
6. Usar búsquedas ILIKE '%texto%' para campos de texto
7. Adaptar consulta para presentarse como resultado en Excel
8. Si la consulta es abstracta, mostrar SELECT con columnas relevantes
9. **PRIORIZA SIEMPRE QUE LA CONSULTA TRAIGA DATOS IQVIA, aunque sea menos específica**

⚠️ NOTAS SOBRE PERÍODO (NUMERIC YYYYMM):
- 202301 = Enero 2023, 202412 = Diciembre 2024
- Para filtrar 2024 completo: period >= 202401 AND period <= 202412
- Para últimos 6 meses de 2024: period >= 202407 AND period <= 202412
- Para comparar años: FLOOR(period/100) = 2024 vs FLOOR(period/100) = 2023
- NO usar funciones de fecha como DATE_PART, usar aritmética de enteros

⚠️ FORMATO DE RESPUESTA:
- Devuelve ÚNICAMENTE el código SQL puro
- NO incluyas comentarios, títulos o explicaciones
- NO uses formato markdown ni bloques de código
- El SQL debe empezar directamente con SELECT, WITH, etc.
- Termina con punto y coma
- DEBE incluir filtros de período amplios y filtros inclusivos
`; };

